import { render, staticRenderFns } from "./SideHostBar.vue?vue&type=template&id=51521c0c&scoped=true&"
import script from "./SideHostBar.vue?vue&type=script&lang=js&"
export * from "./SideHostBar.vue?vue&type=script&lang=js&"
import style0 from "./SideHostBar.vue?vue&type=style&index=0&id=51521c0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51521c0c",
  null
  
)

export default component.exports